import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { getAllIndustries } from '../pages/industries/industriesData';
import '../styles/IndustriesSection.css';

const fadeUp = (delay = 0) => ({
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.65, ease: [0.22, 1, 0.36, 1], delay },
});

export default function IndustriesSection() {
  // Featured industries matching the navbar dropdown
  const FEATURED_INDUSTRIES = ['healthcare', 'fintech', 'logistics', 'edtech', 'retail', 'saas'];
  const allIndustries = getAllIndustries();
  const industries = allIndustries.filter((ind) => FEATURED_INDUSTRIES.includes(ind.id));

  return (
    <section className="section industries-section">
      <div className="container">
        <motion.div className="industries__header" {...fadeUp(0)}>
          <div className="section__tag">Vertical Expertise</div>
          <h2 className="section__title">Industries We Serve</h2>
          <p className="industries__subtitle">
            We deliver industry-focused technology solutions tailored to unique operational and customer challenges.
          </p>
        </motion.div>

        <div className="industries__grid">
          {industries.map((industry, idx) => {
            return (
              <motion.div
                key={industry.id}
                className="industry-card"
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                whileHover={{ y: -8 }}
                viewport={{ once: true }}
                transition={{
                  duration: 0.65,
                  ease: [0.22, 1, 0.36, 1],
                  delay: idx * 0.06
                }}
              >
                <div className="industry-card__image-container">
                  <img
                    src={industry.image}
                    alt={industry.title}
                    className="industry-card__image"
                  />
                </div>

                <div className="industry-card__content">
                  <h3 className="industry-card__name">{industry.title}</h3>

                  <p className="industry-card__description">{industry.overview}</p>

                  <div className="industry-card__capabilities">
                    {industry.solutions.slice(0, 3).map((solution, idx) => (
                      <span key={idx} className="capability-tag">
                        {solution.title}
                      </span>
                    ))}
                  </div>

                  <Link
                    to={`/industries/${industry.slug}`}
                    className="industry-card__cta"
                    style={{ borderColor: industry.accentColor + '40' }}
                  >
                    Learn More →
                  </Link>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
